import type { AnyRoute } from "@tanstack/react-router";

import { createCatalogListRoutes } from "./createCatalogListRoutes";
import type { CatalogRouteDeps } from "./catalogRouteContext";

export type {
  CatalogRouteDeps,
  CatalogRouteFactory,
} from "./catalogRouteContext";

// One factory per area allows independent extension without contention
export function createCatalogRoutes(deps: CatalogRouteDeps): AnyRoute[] {
  return [...createCatalogListRoutes(deps)];
}
